import { gql } from '@apollo/client';

export const CREATE_BUSINESS_FORM = gql`
  mutation CreateBusinessForm($form: String!, $brand: String!) {
    createBusinessForm(input: { form: $form, brand: $brand }) 
  }
`;